/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { Owner } from "../../../models/owner.model"
import { Payment, PaymentStatus } from "../../../models/payment.model"
import { Tenant } from "../../../models/tenant.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { PAYMENT_ENDPOINT } from "../payment.endpoint"

let tenantCollection: CollectionQuery
let tenantCountCollection: CollectionQuery
let ownersOfTenantCollection: CollectionQuery
let archivedTenantCollection: CollectionQuery
const paymentQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getTenant: builder.query<Payment, string>({
      query: (id: string) => ({
        url: `${PAYMENT_ENDPOINT.detail}/${id}`,
        method: "get",
      }),
      providesTags: ["Payment"],
    }),

    getPayments: builder.query<Collection<Payment>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PAYMENT_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Payments"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   PaymentCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countPayments: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PAYMENT_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Payments"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   PaymentCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getArchivedPayment: builder.query<Payment, string>({
      query: (id: string) => ({
        url: `${PAYMENT_ENDPOINT.archivedPayment}/${id}`,
        method: "get",
      }),
      providesTags: ["Archived Payment"],
    }),

    getArchivedPayments: builder.query<Collection<Payment>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PAYMENT_ENDPOINT.archivedPayments}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Archived Payments"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   archivedPaymentCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    createPayment: builder.mutation<Payment, any>({
      query: (newData: any) => ({
        url: `${PAYMENT_ENDPOINT.create}`,
        method: "post",
        data: newData,
        permissions: "manage-payments",
      }),
      invalidatesTags: ["Payments", "Count Payments"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updatePayment: builder.mutation<Payment, any>({
      query: (newData: any) => ({
        url: `${PAYMENT_ENDPOINT.update}`,
        method: "put",
        data: newData,
        permission: "manage-payments",
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((Payment) => {
            //           if (Payment.id === data.id) return data
            //           else {
            //             return Payment
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    updateFsNumber: builder.mutation<Payment, any>({
      query: (newData: any) => ({
        url: `${PAYMENT_ENDPOINT.updateFsNumber}`,
        method: "post",
        data: newData,
        permission: "manage-payments",
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((Payment) => {
            //           if (Payment.id === data.id) return data
            //           else {
            //             return Payment
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    changePaymentStatus: builder.mutation<
      Payment,
      { id: string; data: FormData }
    >({
      query: (data: { id: string; data: FormData }) => ({
        url: `${PAYMENT_ENDPOINT.changePaymentStatus}`,
        method: "post",
        permission: "manage-payments",
        data: data.data,
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((Payment: Payment) => {
            //           if (Payment.id === data.id) return data
            //           else {
            //             return Payment
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   paymentQuery.util.updateQueryData("getPayment", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    archivePayment: builder.mutation<Payment, { id: string; reason: string }>({
      query: (data) => ({
        url: `${PAYMENT_ENDPOINT.archive}`,
        method: "delete",
        data: data,
        permission: "manage-payments",
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((Payment) => {
            //         if (Payment.id === arg.id) {
            //           return data
            //         } else {
            //           return Payment
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getPayment",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getArchivedPayment",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully archived")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    deletePayment: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${PAYMENT_ENDPOINT.delete}/${id}`,
        method: "delete",
        permission: "manage-payments",
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getArchivedPayments",
            //     archivedPaymentCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter((Payment) => Payment.id !== id)
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    restorePayment: builder.mutation<Payment, string>({
      query: (id: string) => ({
        url: `${PAYMENT_ENDPOINT.restore}/${id}`,
        method: "post",
        permission: "manage-payments",
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((Payment) => {
            //         if (Payment.id === id) {
            //           return data
            //         } else {
            //           return Payment
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   paymentQuery.util.updateQueryData("getPayment", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   paymentQuery.util.updateQueryData(
            //     "getArchivedPayment",
            //     id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully restored")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
  }),
  overrideExisting: true,
})
export const {
  useLazyCountPaymentsQuery,
  useLazyGetArchivedPaymentQuery,
  useLazyGetArchivedPaymentsQuery,
  useLazyGetPaymentsQuery,
  useLazyGetTenantQuery,
  useCreatePaymentMutation,
  useDeletePaymentMutation,
  useUpdatePaymentMutation,
  useArchivePaymentMutation,
  useRestorePaymentMutation,
  useChangePaymentStatusMutation,
  useUpdateFsNumberMutation,
} = paymentQuery
